// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a.post-link {
  text-decoration: none;
  color: inherit;
  display: block;
  cursor: pointer;
}
a.post-link:hover {
  text-decoration: none;
}
a.post-link:visited {
  color: inherit;
}

.pgc-content .content {
  padding: 10px 0px 10px 0px;
}
.pgc-content .img_container {
  margin-top: 10px;
  width: calc(323 / var(--base-width) * 100vw);
  height: calc(190 / var(--base-width) * 100vw);
}
.pgc-content .img_container .myImage {
  width: 100%;
  height: 100%;
  background-position: center !important;
  background-size: cover !important;
  background-image: url("/assets/img/sample.png");
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/expert-post-list2/expert-post-list2.component.scss"],"names":[],"mappings":"AACA;EACE,qBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AAAF;AAEE;EACE,qBAAA;AAAJ;AAGE;EACE,cAAA;AADJ;;AAUE;EACE,0BAAA;AAPJ;AAUE;EACE,gBAAA;EACA,4CAAA;EACA,6CAAA;AARJ;AAUI;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,iCAAA;EACA,+CAAA;EAEA,mBAAA;AATN","sourcesContent":["// SEO 優化：將主要區域包裝在 a 標籤內，移除預設樣式\na.post-link {\n  text-decoration: none;\n  color: inherit;\n  display: block;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:visited {\n    color: inherit;\n  }\n}\n\n.pgc-content {\n  // margin-left: 26px;\n  // margin-right: 26px;\n  // margin-top: 32px;\n\n  .content {\n    padding: 10px 0px 10px 0px;\n  }\n\n  .img_container {\n    margin-top: 10px;\n    width: calc(323 / var(--base-width) * 100vw);\n    height: calc(190 / var(--base-width) * 100vw);\n\n    .myImage {\n      width: 100%;\n      height: 100%;\n      background-position: center !important;\n      background-size: cover !important;\n      background-image: url(\"/assets/img/sample.png\");\n\n      border-radius: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
